import { get } from "http";
import axios from "../config/axios";

// [18]  GET:/insts/by_inst_name/<string: name>
const getInstsByName = async (name: string) => {
    const res = await axios.GENERAL.get("/insts/by_inst_name/"+name)
    if(res.status === 200){
        // console.log("getInstsByName", res);
        return res.data
    }
}
const getInstByNameExact = async (name: string) => {
    let query_div = name.split("/");
    let query = query_div[query_div.length - 1];
    const  res_search = await getInstsByName(query)
    // console.log("get insts of result data", res_search.insts, name, query)
    let inst_list = res_search.insts

    if (inst_list.length === 1) {
        return inst_list[0]
    } else if (inst_list.length > 1) {
        // find the exact match
        const res_exact = inst_list.filter((i:any) => i.inst.primaryname === name)
        // console.log("getInstByNameExact-name", name, query, inst_list)
        // console.log("getInstByNameExact", res_exact)
        return res_exact[0]
    }

}
// [18-1]
const getInstsByType = async (stype:string) => {
  const res = await axios.GENERAL.get("/insts/by_type/"+stype)
  if (res.status === 200) {
    console.log("getInstsByType", res);
    return res.data
  }
}
// [18-2]
const getInstsByClass = async (sclass:string) => {
  const res = await axios.GENERAL.get("/insts/by_class/"+sclass)
  if (res.status === 200) {
    console.log("getInstsByClass", res);
    return res.data
  }
}
// [18-3]
const getInstsByCategory = async (scat:string) => {
  const res = await axios.GENERAL.get("/insts/by_category/"+scat)
  if (res.status === 200) {
    console.log("getInstsByCategory", res);
    return res.data
  }
}
// [18-4]
const getInstById = async (inst_id:string) => {
    const res = await axios.GENERAL.get("/inst/info/"+inst_id)
    if (res.status === 200) {
        console.log("getInstByInstId", res);
        return res.data
    }
}
// [18-5]
const getInstsByIds = async (inst_ids:string[]) => {
    const res = await axios.GENERAL.post("/insts/by_inst_ids", {"inst_ids":inst_ids})
    if (res.status === 200) {
        // console.log("getInstsByInstIds", res);
        return res.data
    }
}
// [19-1] GET:/psnorders/related_by_inst/<inst:inst_id>
const getPsnordersByInstIds = async (inst_ids: any) => {
  let psnorders:any = []
  for (let i = 0; i < inst_ids.length; i++) {
    // console.log(inst_ids[i])
    const res = await axios.GENERAL.get("/psnorders/related_by_inst/"+inst_ids[i])
    if (res.status === 200) {
      psnorders.push(...res.data.rel_inst_psnorders)
    }
  }
  psnorders.sort((a:any, b:any) => a.psnorder_id - b.psnorder_id)
//   console.log("getPsnordersByInstId", psnorders);
  return psnorders
}

// [19-3] GET:/tocs/related_by_inst/<int:inst_id>
const getTocsByInstId = async (inst_id: number) => {
    const res = await axios.GENERAL.get("/tocs/related_by_inst/"+inst_id)
    if (res.status === 200) {
        console.log("getTocsByInst", res);
        return res.data.rel_inst_tocs
    }
}

export default {
    getInstsByName,
    getInstByNameExact,
    getInstsByType,
    getInstsByClass,
    getInstsByCategory,
    getInstById,
    getInstsByIds,
    getTocsByInstId,
    getPsnordersByInstIds
};